import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/market-place/services/product.service';
import { environment } from 'src/environments/environment';
import {
  Categories,
  dataCategorie,
} from '../../login/pages/perfil/interfaces-perfil/interfacesPerfil';

@Component({
  selector: 'app-productos-marketplace-home',
  templateUrl: './productos-marketplace-home.component.html',
  styleUrls: ['./productos-marketplace-home.component.scss'],
})
export class ProductosMarketplaceHomeComponent implements OnInit {
  @Input() productCategories:dataCategorie[];
  @Input() rutaPaginador:string;
  @Output() searchWithCategory = new EventEmitter();
  imagesCategories: dataCategorie[] = [];

  slidesOpt = {
    slidesPerView: 1.2,
    speed: 400,
    breakpoints: {
      360: {
        slidesPerView: 2.2
      },
      800: {
        slidesPerView: 4.5
      }
    }
  };

  url: string = environment.url;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productService: ProductService
  ) {}

  ngOnInit() {
    this.imagesCategories.unshift({
      name: 'Todas',
      large_img: 'assets/img/background/todos.png',
      id: 'todos'
    })

    if(this.productCategories){
      this.imagesCategories = this.productCategories;
      return;
    }
    this.productService.getCategories().subscribe((res: Categories) => {
      const categories: dataCategorie[] = res.data;
      categories.forEach((categoryData) => {
        this.imagesCategories.push({
          name: categoryData.name,
          large_img: `${categoryData.large_img}`,
          id: categoryData.id,
        });
      });
    });
  }

  searchBy(categoria: any) {
    if(this.productCategories){
      const page = this.route.snapshot.paramMap.get('page');
      this.router.navigate([`${this.rutaPaginador}/${page}`], {
        queryParams: { categoria },
        relativeTo: this.route,
        queryParamsHandling: 'merge',
      });
      return
    }
    this.router.navigate(['/market-place/search/1'], {
      queryParams: { categoria },
      relativeTo: this.route,
    });
  }
}
